export default "__VITE_ASSET__cf9ea1d1__"